import React from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { ShieldCheck } from 'phosphor-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { useOptionsMode } from '../../context/OptionsModeContext';
import { useOptionsLocale } from '../../context/OptionsLanguageContext';

export const OptionsOnboardingCard = ({
  title,
  description,
  connectLabel,
  securityTitle,
  securityBody,
  securityDetails,
}) => {
  const navigate = useNavigate();
  const { enterDemoMode } = useOptionsMode();
  const { t } = useOptionsLocale();

  return (
    <Card className="border-white/10 bg-[linear-gradient(135deg,rgba(255,255,255,0.05),rgba(255,255,255,0.02))] text-white shadow-none" data-testid="options-onboarding-card">
      <CardContent className="space-y-8 p-6 sm:p-8 lg:p-10">
        <div className="space-y-4">
          <div className="inline-flex items-center gap-2 rounded-full border border-[#00E676]/20 bg-[#00E676]/10 px-3 py-1 text-xs font-semibold uppercase tracking-[0.24em] text-[#9BFFBE]" data-testid="options-onboarding-badge">
            GENI Options
          </div>
          <div className="space-y-3">
            <h2 className="text-3xl font-black font-heading tracking-tight text-white sm:text-4xl" data-testid="options-onboarding-title">
              {title}
            </h2>
            <p className="max-w-2xl text-sm text-white/65 sm:text-base" data-testid="options-onboarding-description">
              {description}
            </p>
          </div>
        </div>

        <div className="flex flex-wrap gap-3" data-testid="options-onboarding-actions">
          <Button asChild size="lg" data-testid="options-onboarding-connect-button">
            <Link to="/options/connect">{connectLabel}</Link>
          </Button>
          <Button
            type="button"
            variant="outline"
            size="lg"
            className="border-white/10 bg-white/[0.03] text-white hover:bg-white/10 hover:text-white"
            onClick={() => {
              enterDemoMode();
              navigate('/options');
            }}
            data-testid="options-onboarding-demo-button"
          >
            {t('common.viewDemo')}
          </Button>
        </div>

        <div className="flex items-start gap-3 rounded-3xl border border-white/10 bg-black/30 px-4 py-4" data-testid="options-onboarding-security-note">
          <ShieldCheck className="mt-0.5 h-5 w-5 text-[#00E676]" weight="duotone" />
          <div className="space-y-1.5">
            <p className="text-sm font-semibold text-white" data-testid="options-onboarding-security-title">{securityTitle}</p>
            <p className="text-sm text-white/60" data-testid="options-onboarding-security-body">{securityBody}</p>
            <p className="text-xs uppercase tracking-[0.18em] text-white/35" data-testid="options-onboarding-security-details">{securityDetails}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default OptionsOnboardingCard;